module.exports = __webpack_public_path__ + "img/wallet.65c4f0e0.svg";